export default {
      id: "eye-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#eye",
      toString: function () {
        return this.url;
      }
    }